module.exports = __webpack_public_path__ + "img/labsolu.3085cfc0.png";